module.exports = __webpack_public_path__ + "static/img/1004_small.bdd6a5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1004_small.png
// module id = Sgri
// module chunks = 1